import React, { useEffect, useState } from 'react'
import CarRegistrationNumberPlate from '../../../../../components/Elements/CarRegistrationNumberPlate'
import { FaCalendarAlt, FaChevronLeft } from 'react-icons/fa'
import { Card, Col, Row, Tooltip } from 'antd'
import { Link, useNavigate } from 'react-router-dom'
import carPlaceholder from '../../../../../assets/images/car.png'
import { useDispatch, useSelector } from 'react-redux'
import { setAppLoading, setMessage } from '../../../../../store/common/generalSlice'
import { getAllServices, getFormattedDateTime, getLastLayerServices, getServicesList } from '../../../../../config/utils'
import Button from '../../../../../components/FormElements/Button'
import { LuMapPin } from 'react-icons/lu'
import { FaCircleCheck } from 'react-icons/fa6'
import Modal from '../../../../../components/Modal'
import useBookingApi from '../../../../../config/hooks/api/booking/useBookingApi'
import Prompt from '../../../../../components/Prompt'
import BookingForm from '../../../../../components/BookingForm'
import { filtersDataFormatter } from '../../../../../config/utils/FiltersDataFormatter'
import { filtersSelectedDataFormatter } from '../../../../../config/utils/FiltersSelectedDataFormatter'
import { extractValues } from '../../../../../config/utils/ExtractValues'
import { getMatchingIds } from '../../../../../config/utils/GetMatchingIds'
import './index.css'

const RequestDetails = () => {
    const requestDetails = useSelector(state => state?.requests?.selectedRequestDetails)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { deleteBooking } = useBookingApi()

    const [openModal, setOpenModal] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [deletePromptMessage, setDeletePromptMessage] = useState('')
    const [rebookData, setRebookData] = useState(null)
    const [formattedData, setFormattedData] = useState(null)
    const [servicesLength, setServicesLength] = useState(0);

    useEffect(() => {
        if (requestDetails) {
            setServicesLength(requestDetails?.services?.length)
        }
    }, [requestDetails])


    const closeModal = () => {
        setOpenModal(false)
    }

    const handleDeleteBookingPrompt = () => {
        setOpenModal(true)
        setDeletePromptMessage('Are you sure you want to delete this booking?')
    }

    const handleDeletePromptResponse = (res) => {
        if (res === true) handleDeleteBooking()
        closeModal()
    }

    const handleDeleteBooking = async () => {
        try {
            const response = await deleteBooking(requestDetails?.id)
            if (response) {
                dispatch(setMessage(response?.data?.message))
                navigate('/requests')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleRebooking = () => {
        setEditMode(true)

        const { address, latitude, longitude, postalCode, details, selectedCategories } = requestDetails
        console.log("selectedCategories", requestDetails)
        // const initialData = filtersDataFormatter(selectedCategories);
        // let selectedData;
        // let selectedValues;
        // if (initialData) {
        //     selectedData = filtersSelectedDataFormatter(initialData);
        //     // extract values func is used to get only the array of selected values from our 
        //     // modal's selected values object format.
        //     // selectedValues = extractValues(selectedData);
        // }
        // setFormattedData({
        //     initialData,
        //     selectedData
        // });

        setRebookData({
            carRegNo: requestDetails?.vehicleRegistrationNo,
            location: { address, latitude, longitude, postalCode },
            // passing selected Values which is only an array of third layer values to get
            // the correct count initially and on deselect or select of any values from modal.
            // services: selectedValues,
            details
        })
    }

    const bookingFormDataOrStatusHandler = async (data) => {
        const { selectedCategories } = requestDetails;
        try {
            dispatch(setAppLoading(true))
            const temp = structuredClone(data);
            let finalSelectedValues;
            const payload = {
                ...temp?.fetchedVehicleData,
                ...temp?.location,
                quote: requestDetails?.quote,
                ...temp
            }

            if (selectedCategories) {
                // handling a specific case here to get an array of ids of first Layer
                // second Layer and third Layer based on the third layer values only.
                finalSelectedValues = getMatchingIds(selectedCategories, data?.services);
            }

            payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
            // payload.services = [].concat(...Object.values(temp?.services))
            payload.services = finalSelectedValues //dev env
            // payload.services = [77,80,83] //QA env
            payload.year = payload.year + ''

            const keysToDelete = [
                'vehicleRegistrationNumber',
                'id',
                'createdAt',
                'carRegNo',
                'isApproved',
                'status',
                'updatedAt',
                'forgot',
                'fetchedVehicleData',
                'location',
                'userId'
            ]
            for (let i = 0; i < keysToDelete.length; i++) {
                delete payload[keysToDelete[i]]
            }

            console.log(payload, 'edit booking')
            // const response = await createBooking(payload)
            // if (response) {
            //     dispatch(setAppLoading(false))

            //     dispatch(setMessage(response?.data?.message))
            //     navigate('/booking/my-bookings')
            // }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleBack = () => {
        if (editMode) setEditMode(false)
        else navigate('/')
    }

    useEffect(() => {
        console.log(requestDetails)
        dispatch(setAppLoading(true))
    }, [])


    return (
        <Row className='mb-4'>
            <Col
                span={24}
                className={`sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}
            >
                <div className='flex justify-between items-center'>
                    <h5 className='heading-5 text-slate-600 font-semibold'>Details</h5>
                    <div onClick={handleBack} className='cursor-pointer flex items-center'>
                        <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                        <small className='ml-2 font-medium'>Back</small>
                    </div>
                </div>
            </Col>
            <Col
                md={editMode ? 18 : 24}
                sm={editMode ? 16 : 24}
                xs={24}
                className={`${editMode ? 'md:pl-20 md:pr-2' : 'md:px-20'} sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}
            >
                {
                    requestDetails ? (
                        <Card
                            key={'request' + requestDetails?.id}
                            bordered={false}
                            className='mb-4 rounded-md'

                        >
                            <div className='flex sm:flex-row flex-col justify-between mb-2'>
                                <div
                                    className='flex sm:flex-row flex-col sm:w-1/2 w-full sm:mb-0 mb-2 cursor-pointer'
                                    onClick={() => navigate(`/request/${requestDetails?.id}`)}
                                >
                                    <div className='flex sm:flex-row flex-col justify-center items-center mb-4'>
                                        <img src={carPlaceholder} alt='car' className='img-fluid h-[60px]' />
                                    </div>
                                    <div className='sm:ml-4'>
                                        <div className='mb-4 ml-1'>
                                            {/* <div className='flex justify-center sm:justify-start'>
                                                <h3 className='heading-3 font-bold mb-1'>
                                                    {
                                                        requestDetails?.services &&
                                                            requestDetails?.services.length ?
                                                            requestDetails?.services[0].name : ''
                                                    }
                                                </h3>
                                            </div> */}
                                            <div className='flex justify-center sm:justify-start'>
                                                <h3 className='heading-3 font-bold mb-1'>
                                                    {
                                                        requestDetails?.selectedCategories &&
                                                            requestDetails?.selectedCategories?.length > 0 ?
                                                            requestDetails?.selectedCategories[0].name : '-'
                                                    }
                                                </h3>
                                            </div>
                                            {/* <div className='flex justify-center sm:justify-start'>
                                                {
                                                    requestDetails?.services &&
                                                        requestDetails?.services.length ? (
                                                        <React.Fragment>
                                                            {requestDetails?.services.slice(1, 3).map((service, index) => (
                                                                <span key={service?.id}>
                                                                    <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                        {
                                                                            service?.name.length > 25 ?
                                                                                service?.name?.slice(0, 25) + '...' :
                                                                                service?.name
                                                                        }

                                                                        {index < requestDetails?.services.slice(1, 3).length - 1 &&
                                                                            (<span className='mx-1'>|</span>)}
                                                                        {index == 2 && requestDetails?.services.length > 3 ?
                                                                            (<span className='mr-1'>...</span>) : ''}
                                                                    </p>
                                                                </span>
                                                            ))}
                                                            {requestDetails?.services?.length > 3 ? (
                                                                <Tooltip title={getServicesList(requestDetails?.services)}>
                                                                    <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                </Tooltip>
                                                            ) : ''}
                                                        </React.Fragment>
                                                    ) : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                                }
                                            </div> */}
                                            {/* <div className='flex justify-center sm:justify-start'>
                                                {
                                                    requestDetails?.selectedCategories &&
                                                        requestDetails?.selectedCategories?.length > 0 ? (
                                                        <React.Fragment>
                                                            {
                                                                requestDetails?.selectedCategories[0].subServices?.length > 0 ?
                                                                    <span className='flex gap-1 items-center'>
                                                                        <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                            {requestDetails?.selectedCategories[0].name + ','}
                                                                        </p>
                                                                        <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                            {requestDetails?.selectedCategories[0].subServices[0]?.name + ' ...'}                                                                            </p>
                                                                    </span>
                                                                    :
                                                                    <p>-</p>

                                                            }
                                                            {requestDetails?.selectedCategories?.length > 0 &&
                                                                requestDetails?.selectedCategories[0]?.subServices?.length > 0 &&
                                                                requestDetails?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0
                                                                ? (
                                                                    <Tooltip title={getServicesList(requestDetails?.selectedCategories[0]?.subServices[0]?.subServices, true)}>
                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                    </Tooltip>
                                                                ) : ''}
                                                        </React.Fragment>
                                                    ) : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                                }
                                            </div> */}
                                            <div className='flex justify-start mt-2'>
                                                {
                                                    requestDetails?.services &&
                                                        servicesLength > 0 ? (
                                                        <React.Fragment>
                                                            {
                                                                requestDetails?.services?.slice(0, 3)?.map((service) => {
                                                                    if (service?.name) {
                                                                        return (
                                                                            <span className='flex gap-1 items-center justify-start'>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                                                                    {service?.name + ','}
                                                                                </p>
                                                                            </span>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                            {servicesLength > 4 && <span>...</span>}
                                                            {servicesLength > 4 &&
                                                                (
                                                                    <Tooltip title={getServicesList(requestDetails?.services, false)}>
                                                                        <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                    </Tooltip>
                                                                )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <small className='text-xs'>Services not available</small>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex sm:flex-row flex-col justify-end sm:w-1/2 w-full sm:pr-4'>
                                    <div className='mb-2'>
                                        <CarRegistrationNumberPlate regNumber={requestDetails?.vehicleRegistrationNo} />
                                    </div>
                                    {/* <div className='sm:ml-2 mb-2 edit-detail-btn'>
                                        <Button.Basic
                                            onClick={handleRebooking}
                                            disabled={false}
                                            icon={null}
                                            loading={false}
                                            type="primary"
                                            size='small'
                                            text='Edit Details'
                                            className='bg-black sm:w-fit w-full px-3 py-5 text-xs'
                                        />
                                    </div> */}
                                    <div className='sm:ml-2 mb-2 delete-btn'>
                                        <Button.Basic
                                            onClick={() => handleDeleteBookingPrompt(requestDetails?.id)}
                                            disabled={false}
                                            icon={null}
                                            loading={false}
                                            type="primary"
                                            size='small'
                                            text='Delete'
                                            className='bg-[#c00034] sm:w-fit w-full px-3 py-5 text-xs'
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='mb-4'>
                                <hr className='border-dashed border-1 border-gray-200 mb-3' />

                                <div className='flex sm:flex-row flex-col'>
                                    <div className='flex items-center mb-3 sm:mr-4'>
                                        <div className='w-[20px] mr-2'>
                                            <LuMapPin className='text-2xl text-white bg-primary p-[3px] rounded-full' />
                                        </div>
                                        <small className='text-xs font-md'>
                                            {requestDetails?.address}
                                        </small>
                                    </div>
                                    <div className='flex items-center mb-3 sm:mr-4'>
                                        <div className='w-[20px] mr-2'>
                                            <FaCalendarAlt className='bg-[#fa3434] text-white rounded-full p-[5px] text-2xl' />
                                        </div>
                                        <small className='text-xs font-md'>
                                            {getFormattedDateTime(requestDetails?.createdAt, 'DD-MM-YYYY HH:mm')}
                                        </small>
                                    </div>
                                </div>

                                <hr className='border-dashed border-1 border-gray-200' />
                            </div>

                            <div className='mb-4'>
                                <h6 className='heading-6 font-bold text-sm mb-4'>Services Requested:</h6>
                                <div className='flex sm:flex-row flex-col mb-4 mt-3'>
                                    {servicesLength > 0 ?
                                        getLastLayerServices(requestDetails?.services)
                                        :
                                        <small className='text-xs'>Services not available</small>
                                    }
                                </div>
                                <hr className='border-dashed border-1 border-gray-200' />
                            </div>

                            <div className='mb-4'>
                                <h6 className='heading-6 font-bold text-sm mb-2'>Additional Info/Note</h6>
                                <small className='text-xs font-md'>{requestDetails?.details}</small>
                            </div>

                        </Card>
                    )
                        : 'No Data Available'
                }
            </Col>
            {
                editMode && (
                    <Col md={6} sm={8} xs={24} className='px-2 pt-6'>
                        <div className='bg-black rounded-md p-4 w-full'>
                            <h6 className='heading-6 text-md text-white font-bold mb-1'>Book Service</h6>
                            <small className='text-xs text-white mb-4 inline-block'>Vehicle Registration</small>
                            <BookingForm
                                // spServicesData={formattedData.initialData}
                                // selectedFiltersValue={formattedData.selectedData}
                                editData={rebookData}
                                bookingFormDataOrStatusHandler={bookingFormDataOrStatusHandler}
                                isServicesFilled={true}
                            />
                        </div>
                    </Col>
                )
            }
            <Modal.Basic open={openModal} onCancel={closeModal} width={250}>
                <Prompt.Basic
                    message={deletePromptMessage}
                    onChange={handleDeletePromptResponse}
                    closeModal={closeModal}
                />
            </Modal.Basic>
        </Row>
    )
}

export default RequestDetails